import { useState } from "react";
import { useNavigate } from "react-router";

const getQuery = () => {
  if (typeof window !== "undefined") {
    return new URLSearchParams(window.location.search);
  }
  return new URLSearchParams();
};

const getQueryStringVal = (key: string): string | null => {
  return getQuery().get(key);
};

const useQueryParam = (key: string, defaultVal: string): [string, (val: string) => void] => {
  const navigate = useNavigate();
  const [query, setQuery] = useState(getQueryStringVal(key) || defaultVal);
  const updateUrl = (newVal: string) => {
    setQuery(newVal);
    const query = getQuery();
    if (newVal.trim() !== "") {
      query.set(key, newVal);
    } else {
      query.delete(key);
    }
    navigate({ search: query.toString() }, { state: { isOnlyQueryChange: true } });
  };
  return [query, updateUrl];
};

export default useQueryParam;
